module.exports = __webpack_public_path__ + "static/media/ubuntu.f02cc321.png";